import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React, { useMemo } from 'react';
import styled from 'styled-components';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionActions from '@material-ui/core/AccordionActions';
import _ from 'lodash';
export var AccordionContext = /*#__PURE__*/React.createContext();
var getAccordionSize = function getAccordionSize(prop) {
  var hasPixelValue = _.includes(prop, 'px');
  if (hasPixelValue) {
    var _$split$, _$split;
    var value = (_$split$ = (_$split = _.split(prop, "px")) === null || _$split === void 0 ? void 0 : _$split[0]) !== null && _$split$ !== void 0 ? _$split$ : '';
    if (!Number.isNaN(value)) {
      return prop;
    }
  }
  return prop === 'large' ? "80px" : "54px";
};
var AccordionStyled = styled(function (_ref) {
  var props = _extends({}, _ref);
  return __jsx(Accordion, props);
}).withConfig({
  displayName: "accordion__AccordionStyled",
  componentId: "sc-1fownbp-0"
})(["--collapsed-height:", ";min-height:var(--collapsed-height) !important;border-color:", " !important;"], function (_ref2) {
  var collapsedSize = _ref2.collapsedSize;
  return getAccordionSize(collapsedSize);
}, function (props) {
  return props.error ? "#e25241" : "#d8dee3";
});
var AccordionSummaryStyled = styled(AccordionSummary).withConfig({
  displayName: "accordion__AccordionSummaryStyled",
  componentId: "sc-1fownbp-1"
})(["height:var(--collapsed-height) !important;&.Mui-focused{background-color:transparent !important;}"]);
var AccordionActionsStyled = styled(AccordionActions).withConfig({
  displayName: "accordion__AccordionActionsStyled",
  componentId: "sc-1fownbp-2"
})([""]);

// mui theme overrides
export var MuiAccordion = {
  root: {
    minHeight: '54px',
    maxWidth: 390,
    borderRadius: 5,
    border: '1px solid',
    borderColor: '#d8dee3',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.07)',
    '&.MuiCollapse-container': {
      marginTop: -16
    }
  }
};
export var MuiAccordionSummary = {
  root: {
    height: '54px',
    padding: '0 21px 0 21px',
    alignItems: 'center',
    transition: 'none',
    '&.Mui-expanded': {
      minHeight: '54px',
      position: 'relative'
    }
  }
};
export var MuiAccordionActions = {
  root: {
    padding: '0 21px 21px 21px'
  }
};
function AccordionWrapper(props) {
  var expanded = props.expanded,
    disabled = props.disabled;
  var contextValue = useMemo(function () {
    return {
      expanded: expanded,
      disabled: disabled
    };
  }, [expanded, disabled]);
  return __jsx(AccordionContext.Provider, {
    value: contextValue
  }, __jsx(AccordionStyled, props));
}
AccordionWrapper.testProps = [{
  children: [__jsx(AccordionSummaryStyled, null, "Summary"), __jsx(AccordionActionsStyled, null, "Details")]
}, {
  children: [__jsx(AccordionSummaryStyled, null, "Summary"), __jsx(AccordionActionsStyled, null, "Details")],
  expanded: true
}];
AccordionSummaryStyled.snapshot = false;
AccordionActionsStyled.snapshot = false;
export { AccordionWrapper as Accordion, AccordionSummaryStyled as AccordionSummary, AccordionActionsStyled as AccordionActions };